import React from 'react';
import { Tab } from '@headlessui/react';
import { classNames } from '@wajeez-web/core/utils';
import { useNavigate, useLocation } from 'react-router-dom';
export interface TabsProps {
  tabs: { text: string; disabled: boolean }[];
  selectedTab: number;
  setSelectedTab: (selected: number) => void;
}
const Tabs = ({ selectedTab, setSelectedTab, tabs }: TabsProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Tab.Group
      defaultIndex={selectedTab}
      // onChange={(selected) => navigate(`/${location.pathname}/${selected}`)}
      vertical={true}
    >
      <Tab.List className="h-[90%] overflow-y-auto flex flex-col p-1 outline-none align-baseline justify-start text-start space-y-2">
        {tabs.map(
          (item, i) =>
            !item.disabled && (
              <Tab
                onClick={() =>
                  navigate(`../${i}`, {
                    replace: true,
                  })
                }
                disabled={item.disabled}
                key={i}
                className={({ selected }) =>
                  classNames(
                    'w-full flex flex-row outline-none space-s-2 p-2.5 text-base leading-5 align-baseline  font-medium text-gray-500 rounded-md',
                    ' text-start ',
                    selectedTab === i
                      ? 'bg-white text-primary '
                      : 'hover:text-primary hover:bg-white'
                  )
                }
              >
                {/* <UserIcon className='h-5 w-5 align-baseline'/> */}

                <div> {item.text}</div>
              </Tab>
            )
        )}
      </Tab.List>
    </Tab.Group>
  );
};

export default Tabs;
